import './Question.scss';

import { IonImg, IonLabel, IonText } from '@ionic/react';
import { useState } from 'react';

import CaretDownRed from '@/assets/icons/caret-down-red.svg';

interface QuestionProps {
  title: string;
  content: string;
}

const Question = ({ title, content }: QuestionProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleToggleQuestion = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <div className="question-container">
      <div className="question" onClick={handleToggleQuestion}>
        <IonLabel className="question-title">{title}</IonLabel>
        <IonImg
          className={isOpen ? 'arrow-down' : 'arrow-up'}
          src={CaretDownRed}
        />
      </div>
      {isOpen && (
        <div>
          <IonText className="text">{content}</IonText>
        </div>
      )}
    </div>
  );
};

export default Question;
